
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AcceptLegalAgreementRequest,
  CompanyLegalAgreementContentResponse,
  LegalAgreementLanguage,
  LegalAgreementToAcceptResponse,
  LegalAgreementType,
  SignedLegalAgreementContentResponse,
  ValidationError,
} from '../models';
import {
    AcceptLegalAgreementRequestFromJSON,
    AcceptLegalAgreementRequestToJSON,
    CompanyLegalAgreementContentResponseFromJSON,
    CompanyLegalAgreementContentResponseToJSON,
    LegalAgreementLanguageFromJSON,
    LegalAgreementLanguageToJSON,
    LegalAgreementToAcceptResponseFromJSON,
    LegalAgreementToAcceptResponseToJSON,
    LegalAgreementTypeFromJSON,
    LegalAgreementTypeToJSON,
    SignedLegalAgreementContentResponseFromJSON,
    SignedLegalAgreementContentResponseToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface AcceptLegalAgreementOperationRequest {
    agreementType: LegalAgreementType;
    companyId: string;
    acceptLegalAgreementRequest: AcceptLegalAgreementRequest;
}

export interface GetLegalAgreementToAcceptRequest {
    agreementType: LegalAgreementType;
    companyId: string;
}

export interface GetPublishedLegalAgreementContentRequest {
    agreementType: LegalAgreementType;
    versionId: string;
    language: LegalAgreementLanguage;
    companyId: string;
}

export interface GetSignedLegalAgreementContentRequest {
    acceptanceId: string;
}

/**
 * 
 */
export class LegalAgreementApi extends runtime.BaseAPI {

    /**
     * Records acceptance of the specified version for the specified company. Accessible to administrators of that company and Malt administrators. The version does not have to be the latest published version. 
     * Accept a published legal agreement version
          */
    async acceptLegalAgreementRaw(requestParameters: AcceptLegalAgreementOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['agreementType'] == null) {
            throw new runtime.RequiredError(
                'agreementType',
                'Required parameter "agreementType" was null or undefined when calling acceptLegalAgreement().'
            );
        }

        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling acceptLegalAgreement().'
            );
        }

        if (requestParameters['acceptLegalAgreementRequest'] == null) {
            throw new runtime.RequiredError(
                'acceptLegalAgreementRequest',
                'Required parameter "acceptLegalAgreementRequest" was null or undefined when calling acceptLegalAgreement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/companies/{companyId}/legal-agreements/{agreementType}/acceptance`.replace(`{${"agreementType"}}`, encodeURIComponent(String(requestParameters['agreementType']))).replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcceptLegalAgreementRequestToJSON(requestParameters['acceptLegalAgreementRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Records acceptance of the specified version for the specified company. Accessible to administrators of that company and Malt administrators. The version does not have to be the latest published version. 
     * Accept a published legal agreement version
          */
    async acceptLegalAgreement(requestParameters: AcceptLegalAgreementOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acceptLegalAgreementRaw(requestParameters, initOverrides);
    }

    /**
     * Returns the identifier of the latest published version of the requested legal agreement type when acceptance is required for the specified company. Accessible to administrators of that company and Malt administrators. Returns no content when no acceptance is required. Does not return the agreement content. 
     * Get the legal agreement version requiring acceptance
          */
    async getLegalAgreementToAcceptRaw(requestParameters: GetLegalAgreementToAcceptRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalAgreementToAcceptResponse>> {
        if (requestParameters['agreementType'] == null) {
            throw new runtime.RequiredError(
                'agreementType',
                'Required parameter "agreementType" was null or undefined when calling getLegalAgreementToAccept().'
            );
        }

        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getLegalAgreementToAccept().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<LegalAgreementToAcceptResponse>({
            path: `/compliance/api/companies/{companyId}/legal-agreements/{agreementType}/agreement-to-accept`.replace(`{${"agreementType"}}`, encodeURIComponent(String(requestParameters['agreementType']))).replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=LegalAgreementToAcceptResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the identifier of the latest published version of the requested legal agreement type when acceptance is required for the specified company. Accessible to administrators of that company and Malt administrators. Returns no content when no acceptance is required. Does not return the agreement content. 
     * Get the legal agreement version requiring acceptance
          */
    async getLegalAgreementToAccept(requestParameters: GetLegalAgreementToAcceptRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalAgreementToAcceptResponse> {
        const response = await this.getLegalAgreementToAcceptRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Returns the content of the specified published version in the requested language, falling back to English when the requested translation is unavailable. Includes current company details for resolving variables before acceptance; the signature mention stays empty until acceptance. Accessible to administrators of the specified company and Malt administrators. The legal agreement must apply to the specified company. 
     * Get the content of a published legal agreement version for PDF rendering
          */
    async getPublishedLegalAgreementContentRaw(requestParameters: GetPublishedLegalAgreementContentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyLegalAgreementContentResponse>> {
        if (requestParameters['agreementType'] == null) {
            throw new runtime.RequiredError(
                'agreementType',
                'Required parameter "agreementType" was null or undefined when calling getPublishedLegalAgreementContent().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling getPublishedLegalAgreementContent().'
            );
        }

        if (requestParameters['language'] == null) {
            throw new runtime.RequiredError(
                'language',
                'Required parameter "language" was null or undefined when calling getPublishedLegalAgreementContent().'
            );
        }

        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getPublishedLegalAgreementContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompanyLegalAgreementContentResponse>({
            path: `/compliance/api/companies/{companyId}/legal-agreements/{agreementType}/versions/{versionId}/contents/{language}`.replace(`{${"agreementType"}}`, encodeURIComponent(String(requestParameters['agreementType']))).replace(`{${"versionId"}}`, encodeURIComponent(String(requestParameters['versionId']))).replace(`{${"language"}}`, encodeURIComponent(String(requestParameters['language']))).replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompanyLegalAgreementContentResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the content of the specified published version in the requested language, falling back to English when the requested translation is unavailable. Includes current company details for resolving variables before acceptance; the signature mention stays empty until acceptance. Accessible to administrators of the specified company and Malt administrators. The legal agreement must apply to the specified company. 
     * Get the content of a published legal agreement version for PDF rendering
          */
    async getPublishedLegalAgreementContent(requestParameters: GetPublishedLegalAgreementContentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyLegalAgreementContentResponse> {
        const response = await this.getPublishedLegalAgreementContentRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get the accepted content and the variable values frozen at acceptance time
          */
    async getSignedLegalAgreementContentRaw(requestParameters: GetSignedLegalAgreementContentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignedLegalAgreementContentResponse>> {
        if (requestParameters['acceptanceId'] == null) {
            throw new runtime.RequiredError(
                'acceptanceId',
                'Required parameter "acceptanceId" was null or undefined when calling getSignedLegalAgreementContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SignedLegalAgreementContentResponse>({
            path: `/compliance/api/legal-agreement-acceptances/{acceptanceId}/content`.replace(`{${"acceptanceId"}}`, encodeURIComponent(String(requestParameters['acceptanceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SignedLegalAgreementContentResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get the accepted content and the variable values frozen at acceptance time
          */
    async getSignedLegalAgreementContent(requestParameters: GetSignedLegalAgreementContentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignedLegalAgreementContentResponse> {
        const response = await this.getSignedLegalAgreementContentRaw(requestParameters, initOverrides);
        return response._data;
    }

}
